import { useMe as r } from "./useMe.js";
const s = () => {
  const {
    data: e
  } = r();
  return ["PROVIDER", "ADMIN"].includes(e?.role ?? "");
};
export {
  s as useIsUserRoleProviderOrAdmin
};
